import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { reset } from "./defineSlice";
import { useLocation } from "react-router-dom";

export default function BasicTab() {
  const [value, setValue] = React.useState(0);
  const pathname = useLocation().pathname.replace("/SiMS_ReactJS", "");
  const dispatch = useDispatch();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    dispatch(reset("onRefresh"));
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={pathname}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab
            label="Define Quota"
            sx={{ textTransform: "none" }}
            component={Link}
            to="quota"
            value={"/define/quota"}
          />
          <Tab
            label="Quota - Copy & Submit"
            sx={{ textTransform: "none" }}
            component={Link}
            to="quota-copy-submit"
            value={"/define/quota-copy-submit"}
          />
        </Tabs>
      </Box>
    </Box>
  );
}
